<template>
  <v-list-group active-class="primary white--text" v-model="isOpen">
    <template v-slot:activator>
      <v-list-item-icon class="pl-1 mr-4">
        <img v-if="!isOpen" :src="coinOff" />
        <img v-else :src="coinOn" />
      </v-list-item-icon>
      <v-list-item-title>Quỹ xu</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item class="px-0" active-class="blue lighten-4 primary--text" link to="/student-credit">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Quản lý quỹ xu</v-list-item-title>
      </v-list-item>
      <v-list-item
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/student-credit-report"
        v-if="this.$auth.policies['view-detail-student-credit-report']"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Báo cáo quỹ xu</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>

<script>
import coinOff from '@/assets/coin-off.svg'
import coinOn from '@/assets/coin-on.svg'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('auth', ['user'])
  },
  data() {
    return {
      isOpen: false,
      coinOff,
      coinOn
    }
  }
}
</script>

<style scoped></style>
